angular.module('mtic.components.navbar')
.directive('navBarRouteView', function (EventManager, language, $log, MapStateService) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
      addText: '=?'
    },
    link: function (scope, element, attrs) {

      var eventManager = new EventManager('navBarRouteView', scope);

      var mainApp;
      var secondaryScreen;
      var subModule;
      var resourceName;

      var main_slug;
      var secondary_slug;
      var subModule_slug;
      var resource_slug;

      eventManager.listen('module:open:resource', function(e, resourceData){
        resource_slug = resourceData.slug;
        resourceName = language.get(resourceData.slug);
        if((!resourceName || resourceName === resourceData.slug) && resourceData.name){
          resourceName = resourceData.name;
        }
      });

      eventManager.listen('module:close:resource', function (e, args) {
        if (!(args && args.isPassive)){
          resource_slug = '';
          resourceName = '';
        }
      });

      eventManager.listen('update:resource:slug:route:name',function(e,resourceData){
        resource_slug = resourceData.slug;
        resourceName = language.get(resourceData.slug);
        if(!resourceName){
          resourceName = resourceData.name;
        }
      });

      eventManager.listen('app:open', function(e, type){
        main_slug = type;
        mainApp = language.get(type);
      });

      eventManager.listen('app:secondary:opened', function(e, type){
        secondary_slug = type;
        secondaryScreen = language.get(type);
        if(!secondaryScreen){
          secondaryScreen = type;
        }
      });

      eventManager.listen('submodule:opened', function(e, moduleData){
        subModule_slug = moduleData.slug;
        subModule = language.get(moduleData.slug);
        if(!subModule){
          subModule = moduleData.name;
        }
      });

      eventManager.listen('submodule:closed', function(e, moduleData){
        subModule_slug = '';
        subModule = '';
      });

      eventManager.listen('update:submodule:slug:route:name', function(e, moduleData){
        subModule_slug = moduleData.slug;
        subModule = language.get(moduleData.slug);
        if(!subModule){
          subModule = moduleData.name;
        }
      });

      eventManager.listen('language:change', function(e, data) {
        if (resource_slug !== ''){
          resourceName = language.get(resource_slug);
        }
        mainApp = language.get(main_slug);
        secondaryScreen = language.get(secondary_slug);
        subModule = language.get(subModule_slug);

      });

      scope.getText = function(){
        var use = (mainApp === 'student') ? language.get('14569') : mainApp;
        return [
          use,
          secondaryScreen,
          subModule,
          resourceName
        ].filter(function(a){return a}).join(' / ');
      }

      scope.getModuleText = function(){
        var txt = scope.addText;
        txt = txt.replace('Modules', language.get('14569'));
        return txt;
      }
      scope.getSubmodText = function(){
        if(!subModule){
          return '';
        }
        var txt = subModule;
        return txt;
      }
      scope.getRestText = function(){
        if(resource_slug && (resource_slug === 'run_like_math' || resource_slug.indexOf('run_like_math') === -1 || resource_slug.indexOf('lv_') === -1)){
          return language.get(resource_slug)
        }else if (resource_slug) {
          var splt = resource_slug.split('_');
          var level = '';
          if(!isNaN(splt[splt.length-1])){
            level = splt[splt.length-1];
          }
          var trans_slug = resource_slug.replace('_'+level, '');
          //run_like_math_obj[trans_slug][language.getCurrentSelectedLanguage()]
          resourceName = language.get(trans_slug)+ ' ' + level;
          return resourceName;
        }
      }

      scope.backToModules = function () {
        eventManager.broadcast('module:change:meta', MapStateService.getMetaStateSlug());
        var focusedSlug = MapStateService.getFocusSlug();
        var activeModule = MapStateService.getActiveModule();
        if(focusedSlug && focusedSlug.indexOf(activeModule) > -1){
          MapStateService.setFocusSlug("");
        }

        subModule_slug = '';
        subModule = '';
        scope.closeResource();
      }

      scope.closeResource = function(){
        if (resource_slug !== ''){
          eventManager.broadcast('module:close:resource');
        }
      }

    }
  }
})
